export const jobDesignationApi = {
    getJobDesignation: 'v1/api/jobdesignation',
    createJobDesignation: 'v1/api/jobdesignation',
    editJobDesignation: 'v1/api/jobdesignation',
    deleteJobDesignation: 'v1/api/jobdesignation',
};
